import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
  return {
    titleText: {
      fontWeight: 'bold !important',
      marginRight: '0.5rem !important',
    },

    tagChip: {
      marginRight: '8px !important',
      marginBottom: '8px !important',
    },

    actionIcon: {
      cursor: 'pointer !important',
    },

    countText: {
      fontSize: '0.8rem !important',
      fontWeight: 'bold !important',
      marginLeft: '0.2rem !important',
    },

    viewsText: {
      fontSize: '0.8rem !important',
      fontWeight: 'bold !important',
    },

    createdAndUpdatedByText: {
      fontSize: '0.8rem !important',
      marginBottom: '5px !important',
    },

    nameAndDate: {
      fontWeight: 'bold !important',
    },

    showMoreLessText: {
      color: theme.palette.secondary.main,
      cursor: 'pointer',
      textDecoration: 'underline',
    },
  };
});
